import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ResizeObserver loop suppression is handled in public/index.html
// (must run before react-error-overlay registers its handler)

// ─── Service Worker registration (push notifications + PWA) ─────
// Nessun handler su beforeinstallprompt: Chrome gestisce l'installazione
// PWA nativamente, senza intervento JS. Questo evita warning Android.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('[SW] Registered, scope:', reg.scope);

        // ── Rilevamento aggiornamenti SW ──
        // Controlla periodicamente se il server ha un nuovo sw.js
        // (importante durante/dopo un deploy)
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          console.log('[SW] Nuovo SW trovato, in attesa di installazione...');

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Nuovo SW installato ma c'è un vecchio SW attivo
              // Ricarica la pagina per usare il nuovo SW
              console.log('[SW] Nuovo SW pronto — ricarico la pagina.');
              window.location.reload();
            }
          });
        });

        // Controlla aggiornamenti ogni 60 secondi dopo il primo caricamento
        setInterval(() => {
          reg.update().catch(() => {});
        }, 60 * 1000);
      })
      .catch((err) => {
        console.warn('[SW] Registration failed:', err);
      });
  });

  // Quando un nuovo SW prende il controllo, ricarica per avere asset aggiornati
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    console.log('[SW] Controller cambiato — ricarico la pagina.');
    window.location.reload();
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
